<div class="privacy-container" [style.visibility]="isGrpdAccepted ? 'hidden' : 'visible'">
    <div>
        <p class="policy-text">Nous utilisons des cookies pour vous proposer la meilleure expérience en ligne.
            En utilisant notre site Web, vous acceptez notre politique d'utilisation des cookies.</p>
        <p class="more-info hand" (click)="moreInfo()">En savoir plus ici.</p>
    </div>
    <button class="ui button secondary accept-btn" (click)="acceptGrpd()">Ok</button>
</div>




// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/privacy-policy/footer/privacy-footer.html